import React from 'react'
import { IconWrapper } from './styles'

type Props = {
  color?: string
}

const RemoveIcon = (props: Props) => {
  return (
    <IconWrapper
      fill={props.color}
      focusable='false'
      viewBox='0 0 24 24'
      aria-hidden='true'
      role='presentation'
    >
      <path d='M19 13H5v-2h14v2z' />
      <path fill='none' d='M0 0h24v24H0z' />
    </IconWrapper>
  )
}

export default RemoveIcon
